// extracted by mini-css-extract-plugin
export default {"tituloOutrosPosts":"Post_tituloOutrosPosts__cojkk","postsRecomendados":"Post_postsRecomendados__jdg74","postRecomendadoItem":"Post_postRecomendadoItem__M2j9M"};